import {AuditDTO, AuditType} from "../../shared/components/audit/audit.types";
import {PageDTO} from "../../core/types/pagination.types";
import {SafeUrl} from "@angular/platform-browser";

export enum SterilizationDeviceState{
    COMPLIANT="COMPLIANT", NON_COMPLIANT="NON_COMPLIANT", DEFECT="DEFECT"
}

export enum StockRating{
    LOW="LOW", GOOD="GOOD", HI="HI"
}

export enum EquipmentType {
    INSTRUMENT="INSTRUMENT",
    DEVICE="DEVICE"
}

export interface SterilizationDeviceJournalEntryToCreate{
    newState: SterilizationDeviceState,
    sterilizationDeviceId: string,
    logContent: string
}

export interface SterilizationDeviceJournalEntry extends AuditType{
    id: string,
    sterilizationDeviceId: string,
    state: SterilizationDeviceState,
    logContent: string
}


export interface Device {
    position?: number;
    id: string;
    name: string;
    series: string;
    retired: boolean;
}

export interface MedicalInstrument extends Device{
    bags:number;
}

export interface SterilizerDeviceDTO extends Device{
    location:string;
    state: SterilizationDeviceState
}

export interface SterilizationCycleDTO{
    id: string;
    labelName: string;
    sterilizerDeviceId: string;
    sterilizationCycleNumber: string;
    programUsed: string;
    sterilizationCycleCountInDay?: number;
    timeOfSterilization: string | number [];
    expirationDate: string | number [];
    operatorName: string,
    result: SterilizationDeviceState,
    observations: string,
    signature: string
}

export interface InstrumentAddTOCycleDTO{
    sterilizationCycleId: string,
    medicalInstrumentId: string,
    numberOfBags: number
}


export class SterilizedInstrument extends AuditDTO{
    id: string;
    sterilizationCycleId: string;
    bagCount: number;
    instrumentId: string;
    medicalInstrumentName: string;
    medicalInstrumentSeries: string;
    used: boolean;
    compliant: boolean;
    friendlyId: string;
    sterilizationDeviceName: string;
    sterilizationDeviceSeries: string;
    sterilizationDeviceCycleCount: string;
    sterilizationDeviceCycleCountInDay: number;
    timeOfSterilization: string | number [];
    expirationDate: string | number [];
    QR:SafeUrl;   // UI only
    HTML:string;  // UI only
}

export class  SterilizationCycleWithInstruments extends AuditDTO {
    sterilizationCycleDTO: SterilizationCycleDTO;
    sterilizationCycleInstruments: SterilizedInstrument[];
}

export class SterilizationCyclePagableDTO extends PageDTO{
    content: SterilizationCycleDTO[];
}

export const printLabelCSS:string = `
        body {
            font-family: Arial, sans-serif;
            margin: 0;
            font-size: 10px;
        }
        .label {
            width: 100%;
            height: 100%;
            margin: auto;
            padding: 2px;
            page-break-after: always;
        }
        .title {
            font-size: 12px;
            font-weight: bold;
            margin: 0 0 0 5px;
            padding: 0;
        }
        .content {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 0;
            padding: 1px;
        }
        .left-column {
            flex: 2;
            text-align: left;
            font-size: 10px;
            line-height: 0.9;
            margin: 0;
            padding: 0;
        }
        .right-column {
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .id {
            font-weight: bold;
            margin: -4px 6px 0 0;
            text-align: right;
        }
        p {
            margin: 0;
            padding: 2px;
        }

        .small{
            margin-top: -2px;
            font-weight: bold;
            font-size: 7px;
        }
`;



